<template>
    <Popup ref="popup" :animation="'scale'">
        <!--div class="airdrop-container"-->
        <div :class="getContainerClass()" :style="{ ...containerStyle, transform: landscapeScale < 1 ? `scale(${landscapeScale})` : 'none' }">
            <img class="close-btn" :src="_global.assetsRoot + '/common/pop_btn_close.png'" @click.stop="hide">
            <img class="title-img" :src="getTitleImage()" />
            <div class="airdrop-title">
                <span class="title-text beba">{{ $t("message.airdropTitle") }}</span>
            </div>
            <div class="airdrop-description">
                <span class="description-text beba">{{ $t("message.airdropDescription") }}</span>
            </div>
            <img class="airdrop-icon" :src="_global.assetsRoot + '/common/pop_icon_airdrop.png'" />
            <div class="collect-btn" @click.stop="collectAirShop()">
                <span class="btn-text beba">{{ $t("message.collectAirdrop") }}</span>
            </div>
            <!--div class="sections-container" @click="collectAirShop()" :class="{ gap: airdrop.length === 2 }">
                <div class="item-container" v-for="(airdrop, i) in airdrop" :key="i"
                    :class="getItemClass(airdrop)">
                    <div class="item">
                        <img :src="airdrop.image">
                        <div class="stars-container" v-if="airdrop.type === 'shop_items'">
                            <img :src="getImagePath('airdrop_star.png')" v-for="n in parseInt(airdrop.item_star)"
                                :key="n">
                        </div>
                    </div>
                    <h2 class="title"><img v-if="airdrop.type === 'coins'"
                            :src="_global.assetsRoot + '/airdrop_coin.png'">{{
                                getTitle(airdrop) }}</h2>
                </div>
            </div-->
        </div>
    </Popup>
</template>

<script>
import api from '../../network/api';
import Popup from '../Popup.vue';
export default {
    props: {
        userID: String
    },
    data() {
        return {
            airdrop: {},
            landscapeScale: 1
        }
    },
    computed: {
        containerStyle() {
            let backgroundImage = this._global.isMobile ? `url(${this._global.assetsRoot}/mobile/pop_airdrop_bg.png)` : `url(${this._global.assetsRoot}/desktop/pop_airdrop_bg.png)`;
            return {
                 backgroundImage: backgroundImage
            };
        }
    },
    created() {
        if (this._global.airdrop) {
            this.airdrop = this._global.airdrop;
        }
        // TEMPORARY: Dummy data for testing if global airdrop is empty
        /*if (!this.airdrop || this.airdrop.length === 0) {
            this.airdrop = [
                {
                    type: 'coins',
                    value: 500
                },
                {
                    type: 'shop_items',
                    item_type: '2',
                    item_star: '3'
                }
            ];
        }*/
        this.addImagePaths();
    },
    methods: {
        show() { 
            if (window.innerWidth > window.innerHeight) {
                this.landscapeScale = Math.min((window.innerHeight * 0.75) / (window.innerWidth * 0.85), 1);
            } else {
                this.landscapeScale = 1;
            }
            this.$refs.popup.show() 
        },
        hide() { this.$refs.popup.hide() },
        collectAirShop() {
            api.collectAirShop(this.userID).then((resp) => {
                //console.log(resp)
                this.$emit('airdrop-collected-coins', resp);
                this.$emit('open-redeem');
                this.hide();
            });
            /*let resp = {
                data: {
                    coins: 100
                }
            }
            this.$emit('airdrop-collected-coins', resp);
            this.$emit('open-redeem');
            this.hide();*/
        },
        getContainerClass(){
            return 'airdrop-container';
        },
        getTitleImage() {
            let userLanguage = this._global.user.lang || 'en';
            const langMap = {
                'pt': 'pt',
                'es': 'es',
                'en': 'en'
            };
            const lang = langMap[userLanguage] || 'en';
            return this._global.assetsRoot + `/common/pop_airdrop_title_${lang}.png`;
        },
        getImagePath(imageName) {
            //return require(`../../assets/images/${imageName}`);
            return this._global.assetsRoot + '/' + imageName;
        },
        getImageForType(airdrop) {
            if (airdrop.type === 'coins') {
                return this.getImagePath('airdrop_coins.png');
            } else if (airdrop.type === 'shop_items') {
                switch (airdrop.item_type) {
                    case '1':
                        return this.getImagePath('wild_card.png');
                    case '2':
                        return this.getImagePath('airdrop_capsule.png');
                    case '3':
                        return this.getImagePath('sticker_pack.png');
                    case '4':
                        return this.getImagePath('airdrop_red_coupon.png');
                    case '5':
                        return this.getImagePath('airdrop_dice.png');
                    case '6':
                        return this.getImagePath('mechanical_gloves.png');
                    case '7':
                        return this.getImagePath('jogo_do_bicho_ticket.png');
                    case '8':
                        return this.getImagePath('magnetic_ball.png');
                    case '9':
                        return this.getImagePath('potion_of_luck.png');
                    case '10':
                        return this.getImagePath('machine_of_spins.png');
                    case '11':
                        return this.getImagePath('VIP voucher points.png');
                    case '12':
                        return this.getImagePath('vacuum cleaner.png');
                    case '13':
                        return this.getImagePath('nutrient.png');
                    default:
                        return '';
                }
            }
        },
        getTitle(airdrop) {
            if (airdrop.type === 'coins') {
                return `${airdrop.value}`;
            } else if (airdrop.type === 'shop_items') {
                switch (airdrop.item_type) {
                    case '1':
                        return '1 Wild Card';
                    case '2':
                        return '1 Time Capsule';
                    case '3':
                        return '1 Sticker Pack';
                    case '4':
                        return '1 Red Coupon';
                    case '5':
                        return '1 Dice';
                    case '6':
                        return '1 Mechanical Gloves';
                    case '7':
                        return '1 Jogo Do Bicho Ticket';
                    case '8':
                        return '1 Magnetic Ball';
                    case '9':
                        return '1 Potion Of Luck';
                    case '10':
                        return '1 Machine Of Spins';
                    case '11':
                        return '1 VIP Voucher';
                    case '12':
                        return '1 Vacuum Cleaner';
                    case '13':
                        return '1 Nutrient';
                    default:
                        return '';
                }
            }
        },
        getItemClass(airdrop) {
            if (airdrop.type === 'coins') {
                return 'item-coins';
            } else if (airdrop.type === 'shop_items') {
                switch (airdrop.item_type) {
                    case '2':
                        return 'item-time-capsule';
                    case '4':
                        return 'item-red-coupon';
                    case '5':
                        return 'item-dice';
                    default:
                        return 'item-dice';
                }
            }
        },
        addImagePaths() {
            this.airdrop.forEach(item => {
                item.image = this.getImageForType(item);
            });
        },
    },
    components: {
        Popup,
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";
@import url('https://fonts.googleapis.com/css2?family=Luckiest+Guy&display=swap');

.airdrop-container {
    background: url($assetRoot + "/desktop/pop_airdrop_bg.png") center no-repeat;
    background-size: 100% 100%;
    width: 100vw;
    height: 80vw;
    aspect-ratio: 1;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;
    transform-origin: center center;

    .close-btn {
        width: 9vw;
        height: 9vw;
        position: absolute;
        top: -2vw;
        right: 0;
        cursor: pointer;
        z-index: 10;
    }

    .title-img {
        width: 100%;
        position: absolute;
        top: -3vw;
        left: 0;
        scale: 0.8;
        z-index: 5;
    }

    .airdrop-title {
        position: absolute;
        top: 15vw;
        left: 0;
        right: 0;
        text-align: center;
        z-index: 5;

        .title-text {
            display: block;
            color: #FFFFFF;
            font-size: 5vw;
            font-weight: bold;
            line-height: 5vw;
            text-shadow:
                -2px -2px 0 #2641bf,
                0px -2px 0 #2641bf,
                2px -2px 0 #2641bf,
                -2px  0px 0 #2641bf,
                2px  0px 0 #2641bf,
                -2px  2px 0 #2641bf,
                0px  2px 0 #2641bf,
                2px  2px 0 #2641bf;
        }
    }

    .airdrop-description {
        position: absolute;
        top: 22vw;
        left: 0;
        right: 0;
        text-align: center;
        z-index: 5;

        .description-text {
            display: block;
            color: #FFFFFF;
            font-size: 4vw;
            font-weight: bold;
            line-height: 7vw;
            text-shadow:
                -1px -1px 0 #2641bf,
                0px -1px 0 #2641bf,
                1px -1px 0 #2641bf,
                -1px  0px 0 #2641bf,
                1px  0px 0 #2641bf,
                -1px  1px 0 #2641bf,
                0px  1px 0 #2641bf,
                1px  1px 0 #2641bf;
        }
    }

    .airdrop-icon {
        position: absolute;
        top: 26vw;
        left: 50%;
        transform: translateX(-50%);
        width: 45vw;
        height: auto;
        z-index: 5;
    }

    .collect-btn {
        position: absolute;
        top: 64vw;
        left: 50%;
        transform: translateX(-50%);
        width: 40vw;
        height: 12vw;
        background: url($assetRoot + "/common/btn_logout_stay.png") center no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        z-index: 5;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-text {
            color: #FFFFFF;
            font-size: 8vw;
            font-weight: bold;
            text-shadow:
                -1px -1px 0 #000000,
                0px -1px 0 #000000,
                1px -1px 0 #000000,
                -1px  0px 0 #000000,
                1px  0px 0 #000000,
                -1px  1px 0 #000000,
                0px  1px 0 #000000,
                1px  1px 0 #000000;
        }
    }

    .gap {
        gap: 72px !important;
    }

    .sections-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 52px;

        .item-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .item {
                width: 190px;
                height: 170px;
                background: url($assetRoot + "/airdop_bg_light.png") center no-repeat;
                background-size: 100% 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;

                img {
                    width: 120px;
                    height: 120px;
                }

                .stars-container {
                    display: flex;
                    gap: 1px;
                    position: absolute;
                    bottom: 32px;
                    right: 20px;

                    img {
                        width: 28px;
                        height: 28px;
                    }
                }
            }

            .title {
                background: url($assetRoot + "/airdrop_collect_text_bg.png") center no-repeat;
                background-size: 100% 100%;
                font-family: "Luckiest Guy", cursive;
                font-size: 32px;
                font-weight: 500;
                margin: 0 !important;
                padding: 4px 12px;
            }
        }
    }

    .item-coins {
        .item>img {
            width: 200px !important;
        }

        .title {
            color: #ffe035;
            -webkit-text-stroke-width: 2px;
            -webkit-text-stroke-color: #c26808;
            display: flex;
            align-items: center;

            img {
                width: 36px;
                height: 36px;
                margin-right: 12px;
            }
        }
    }

    .item-dice {
        .title {
            color: #ffffff;
            -webkit-text-stroke-color: #17783c;
            -webkit-text-stroke-width: 2px;
        }
    }

    .item-time-capsule {
        .title {
            color: #ffffff;
            -webkit-text-stroke-color: #c704bf;
            -webkit-text-stroke-width: 2px;
        }
    }

    .item-red-coupon {
        .title {
            color: #ffffff;
            -webkit-text-stroke-color: #c9493b;
            -webkit-text-stroke-width: 2px;
        }
    }
}

/* .mobile override removed — use vw-based responsive base styles above */

.mobile{
    .airdrop-container {
        background: url($assetRoot + "/mobile/pop_airdrop_bg.png") center no-repeat;
        background-size: 100% 100%;
        width: 80vw;
        height: unset;
    }

    .close-btn {
        top: -3vw;
    }

    .title-img {
        top: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/Award.vue